import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";

const defaultForm = {
  id: null,
  nome: "",
  telefono: "",
  mansione: "CAMERIERE",
  localeId: "",
};

export default function EmployeeFormModal({ open, onClose, onSubmit, employee, locali = [] }) {
  const [form, setForm] = useState(defaultForm);

  useEffect(() => {
    if (!employee) {
      setForm(defaultForm);
      return;
    }

    setForm({
      id: employee.id,
      nome: employee.nome || "",
      telefono: employee.telefono || "",
      mansione: employee.mansione || "CAMERIERE",
      localeId: employee.localeId ?? employee.locale?.id ?? "",
    });
  }, [employee]);

  const isValid = useMemo(() => {
    return !!form.nome && !!form.mansione;
  }, [form]);

  const updateField = (field) => (event) => {
    setForm((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = () => {
    if (!isValid) {
      return;
    }

    const rawLocaleId = form.localeId ?? form.locale?.id ?? "";

    onSubmit({
      ...form,
      nome: form.nome.trim(),
      telefono: form.telefono?.trim() || "",
      mansione: form.mansione.trim(),
      localeId: rawLocaleId !== "" && rawLocaleId !== null && rawLocaleId !== undefined ? Number(rawLocaleId) : null,
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{form.id ? "Modifica dipendente" : "Nuovo dipendente"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <TextField fullWidth label="Nome" value={form.nome} onChange={updateField("nome")} required />
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth label="Telefono" value={form.telefono} onChange={updateField("telefono")} />
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Mansione"
              value={form.mansione}
              onChange={updateField("mansione")}
            >
              <MenuItem value="CUCINA">CUCINA</MenuItem>
              <MenuItem value="PIZZERIA">PIZZERIA</MenuItem>
              <MenuItem value="CASSA">CASSA</MenuItem>
              <MenuItem value="CAMERIERE">CAMERIERE</MenuItem>
              <MenuItem value="RIDER">RIDER</MenuItem>
              <MenuItem value="DIRETTORE">DIRETTORE</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Locale predefinito (opzionale)"
              value={form.localeId}
              onChange={updateField("localeId")}
            >
              <MenuItem value="">Nessuno</MenuItem>
              {locali.map((locale) => (
                <MenuItem key={locale.id} value={String(locale.id)}>
                  {locale.nome}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annulla</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={!isValid}>
          Salva
        </Button>
      </DialogActions>
    </Dialog>
  );
}
